import { render, staticRenderFns } from "./PODashboard.vue?vue&type=template&id=7f20caff&scoped=true"
import script from "./PODashboard.vue?vue&type=script&lang=ts"
export * from "./PODashboard.vue?vue&type=script&lang=ts"
import style0 from "./PODashboard.vue?vue&type=style&index=0&id=7f20caff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f20caff",
  null
  
)

export default component.exports